<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.billing.domain_billing.domainZone' | translate }}</th>
				<th>{{ 'adminstat.common.Count' | translate }}</th>
				<th>{{ 'adminstat.billing.domain_billing.list of names' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details">
				<td>
					{{ stat.domain }}
				</td>
				
				<td>
					{{ stat.count }}
				</td>
				
				<td>
					<ngb-accordion #acc="ngbAccordion">
						<ngb-panel title="{{ 'adminstat.common.show all' | translate }}">
							<ng-template ngbPanelContent>
								<ul>
									<li *ngFor="let domain of stat.domains">
										{{ domain.name }}: {{ domain.count }}
									</li>
								</ul>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
